





















































































































































































































































import { orderDetail, approvalRejectEditApi } from "@/api/order";
import { UserModule } from "@/store/module/user";
import { dateFormat } from "@/utils/timeFormat";
import { Vue, Component } from "vue-property-decorator";
// 引入公共组件
import addStaffDialog from "@/components/addStaffDialog.vue";
@Component({
  name: "orderManageEdit",
  // 注册公共组件
  components: {
    addStaffDialog,
  },
})
export default class extends Vue {
  mainData: any = {
    student: {},
    payment_list: [],
    handle_time: "",
    transfer_join_student: {},
    remark: "",
  };
  showBusinessPerson: boolean = false; // 是否选择业务人员
  staffCheckedData: any = []; // 人员选择
  value: string = "";
  showStar: boolean = false;
  showRemark: boolean = false;

  // get 为计算属性
  get username() {
    return UserModule.userInfo.staff_name;
  }
  addStaffChange(val: any) {
    this.staffCheckedData = val;
    if (val.length) {
      this.showBusinessPerson = false;
    }
  }
  created() {
    this.init();
  }
  init() {
    const oid = Number(this.$route.query.id);
    orderDetail({
      order_id: oid,
    }).then((res: any) => {
      if (res.error_code === 0) {
        // 将购买课时和赠送课时转化为数值型
        res.data.item.forEach((item: any) => {
          item.list.forEach((it: any) => {
            it.quantity = Number(it.quantity);
            it.give_product_quantity = Number(it.give_product_quantity);
            // 将每项课程的有效时间放到 item 中，方便数据回填
            if (it.course_end_time === 0) {
              item.efficient_time = "";
            } else {
              item.efficient_time = dateFormat(
                "YYYY-mm-dd",
                new Date(it.course_end_time * 1000)
              );
            }
          });
        });
        // 将后端返回的时间戳直接转化为对应的日期
        res.data.handle_time = res.data.handle_time
          ? dateFormat(
              "YYYY-mm-dd HH:MM",
              new Date(res.data.handle_time * 1000)
            )
          : "-";
        this.mainData = res.data;
        this.staffCheckedData = res.data.belong;
        this.mainData.item.forEach((item: any) => {
          item.list.forEach((it: any) => {
            if (
              it.give_product_quantity > 0 ||
              Number(it.discount_amount) > 0
            ) {
              this.showStar = true;
            }
          });
        });
      }
    });
  }
  handleBack() {
    this.$router.go(-1);
  }
  handleGiveProductQuantity(it: any) {
    // 如果为空，赋初值为 0
    if (!it.give_product_quantity) {
      it.give_product_quantity = 0;
    }
    if (it.give_product_quantity > 0 || Number(it.discount_amount) > 0) {
      this.showStar = true;
    } else {
      this.showStar = false;
    }
  }
  handleRemark() {
    if (this.mainData.remark) {
      this.showRemark = false;
    }
  }
  // 提交编辑信息
  saveConfirm() {
    const data: any = {};
    const list: any[] = [];
    data.order_id = this.mainData.order_id;
    this.mainData.item.map((item: any) => {
      item.list.map((it: any) => {
        list.push({
          order_item_id: it.item_id,
          give_quantity: String(it.give_product_quantity),
          effective_time: item.efficient_time
            ? item.efficient_time.slice(0, 10)
            : "",
        });
      });
    });
    data.item_list = list;
    const staffList: any[] = [];
    this.staffCheckedData.map((item: any) => {
      staffList.push(item.staff_id);
    });
    data.order_belong = staffList;
    data.remark = this.mainData.remark;
    // 未选业务人员
    if (!data.order_belong.length) {
      return (this.showBusinessPerson = true);
    }
    // 未填备注信息
    if (this.showStar && !this.mainData.remark) {
      return (this.showRemark = true);
    }
    approvalRejectEditApi(data).then((res: any) => {
      if (res.error_code === 0) {
        this.init();
        this.$message.success({
          message: "修改成功",
        });
        setTimeout(() => {
          this.$router.push({
            name: "orderManageDetail",
            query: {
              id: this.mainData.order_id,
              from: "orderManageEdit",
            },
          });
        }, 1000);
      }
    });
  }
}
